// on click of a div with class .card-item find in children button[item-info-button] and click on it
document.querySelectorAll(".card-item").forEach((itemElement) =>
  itemElement.addEventListener("click", ({ target }) => {
    if (target.matches(".card-item")) {
      const itemInfoButton = itemElement.querySelector("[item-info-button]")
      if (itemInfoButton) {
        itemInfoButton.click()
      }
    }
  })
)

document.querySelectorAll(".item-image").forEach((itemElement) =>
  itemElement.addEventListener("click", ({ target }) => {
    if (target.matches(".item-image")) {
      const itemInfoButton =
        itemElement.parentElement.parentElement.querySelector(
          "[item-info-button]"
        )
      if (itemInfoButton) {
        itemInfoButton.click()
      }
    }
  })
)

document.querySelectorAll(".item-image").forEach((itemElement) =>
  itemElement.addEventListener("touchend", ({ target }) => {
    if (target.matches(".item-image")) {
      const itemInfoButton =
        itemElement.parentElement.parentElement.querySelector(
          "[item-info-button]"
        )
      if (itemInfoButton) {
        itemInfoButton.click()
      }
    }
  })
)
